import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function TerminalIcon(props: IconProps) {
    return <Icon {...props} iconKey={"terminal"}/>
}
